import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseSafeFormView, BaseView, BaseText } from '@/components/base'
import { AppButton } from '@/components/AppButton'

export const KemCardCreationFailureScreen: React.FC = () => {
  const navigate = useNavigate()

  const handleTryAgain = () => {
    navigate('/kem-card')
  }

  return (
    <BaseSafeFormView
      flex={1}
      bgColor="background.screen"
      className="h-full"
      align="center"
      justify="center"
    >
      <BaseView p={20} gap={24} align="center" flex={1} justify="center">
        {/* Error Icon */}
        <BaseView
          style={{
            width: 80,
            height: 80,
            borderRadius: 40,
            backgroundColor: '#ef4444',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <BaseText fontSize={32} color="white">
            ⚠️
          </BaseText>
        </BaseView>

        <BaseView gap={16} align="center">
          <BaseText
            fontSize={24}
            fontFamily="bold"
            color="label.default"
            textAlign="center"
          >
            Something Went Wrong
          </BaseText>

          <BaseText
            fontSize={16}
            fontFamily="regular"
            color="label.description"
            textAlign="center"
          >
            We couldn't create your card at this time. Please try again later or
            contact support if the problem persists.
          </BaseText>
        </BaseView>

        <BaseView style={{ marginTop: 'auto', width: '100%' }}>
          <AppButton
            onPress={handleTryAgain}
            label="Try Again"
            type="secondaryGray"
          />
        </BaseView>
      </BaseView>
    </BaseSafeFormView>
  )
}
